<template>
  <div
    v-if="pedidoSeleccionado"
    class="content-detalle-linea-pedido padding-horizontal padding-bottom"
  >
    <div class="grid-3">
      <!-- MARCA -->
      <div
        v-if="elementosMostrar.includes('Marca')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.brand') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.Marca?.Nombre || '—' }}
        </div>
      </div>

      <!-- UBICACIÓN -->
      <div
        v-if="elementosMostrar.includes('UbicacionPalesProducidos')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.location') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{
            pedidoSeleccionado.PuntoPaletizado?.UbicacionPalesProducidos?.Nombre
              || '—'
          }}
        </div>
      </div>

      <!-- FECHA DE SALIDA -->
      <div
        v-if="elementosMostrar.includes('FechaSalida')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.departureDateShort') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{
            !isDateNull(pedidoSeleccionado.FechaSalida)
              ? FormatearFecha(pedidoSeleccionado.FechaSalida)
              : '—'
          }}
        </div>
      </div>

      <!-- FECHA DE ENTREGA -->
      <div
        v-if="elementosMostrar.includes('FechaEntrega')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.deliveryDateShort') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{
            !isDateNull(pedidoSeleccionado.FechaEntrega)
              ? FormatearFecha(pedidoSeleccionado.FechaEntrega)
              : '—'
          }}
        </div>
      </div>

      <!-- ALIAS -->
      <div
        v-if="elementosMostrar.includes('AliasCliente')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.alias') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.AliasCliente || '—' }}
        </div>
      </div>

      <!-- REFERENCIA -->
      <div
        v-if="elementosMostrar.includes('ReferenciaPedidoVenta')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.reference') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.ReferenciaPedidoVenta || '—' }}
        </div>
      </div>

      <!-- LOTE -->
      <div
        v-if="elementosMostrar.includes('Lote')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.lot') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.Lote?.Codigo || '—' }}
        </div>
      </div>

      <!-- ORDEN DE PRODUCCIÓN -->
      <div
        v-if="elementosMostrar.includes('OrdenProduccion')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.productionOrderShort') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{
            pedidoSeleccionado.OrdenProduccion
              ? `${pedidoSeleccionado.OrdenProduccion.Serie}/${pedidoSeleccionado.OrdenProduccion.Numero}`
              : '—'
          }}
        </div>
      </div>
    </div>

    <div class="grid-1">
      <!-- DIRECCIÓN DE ENVÍO -->
      <div
        v-if="elementosMostrar.includes('DireccionDeEnvio')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('common.shippingAddress') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.DireccionDeEnvio || '—' }}
        </div>
      </div>

      <!-- OBSERVACIONES PEDIDO VENTA -->
      <div
        v-if="elementosMostrar.includes('ObservacionesPedidoVenta') "
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('production.salesOrderLineDetail.labels.headerObservations') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.ObservacionesPedidoVenta?.Texto || '—' }}
        </div>
      </div>

      <!-- OBSERVACIONES LINEA PEDIDO VENTA -->
      <div
        v-if="elementosMostrar.includes('ObservacionesLineaPedidoVenta')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('production.salesOrderLineDetail.labels.lineObservations') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.ObservacionesLineaPedidoVenta?.Texto || '—' }}
        </div>
      </div>

      <!-- OBSERVACIONES DEL PORTE -->
      <div
        v-if="elementosMostrar.includes('ObservacionesPorte')"
        class="content-detalle-linea-pedido__item"
      >
        <div class="content-detalle-linea-pedido__item--ligh">
          {{ $t('production.salesOrderLineDetail.labels.shippingData') }}
        </div>
        <div class="content-detalle-linea-pedido__item--strong">
          {{ pedidoSeleccionado.ObservacionesPorte?.Texto || '—' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import { isDateNull } from '@/js/utils/date';

defineProps({
  pedidoSeleccionado: {
    type: Object,
    default: null,
  },
  elementosMostrar: {
    type: Array,
    default: () => [],
  },
});

/**
 * @param {string} fecha
 * @returns {string}
 */
function FormatearFecha(fecha) {
  return SoporteFechaYHora.ObtenerDiaMesAno(fecha);
}
</script>

<style scoped lang="scss">
.content-detalle-linea-pedido {
  &__item {
    display: flex;
    flex-direction: column;
    padding-top: var(--f7-typography-padding) !important;

    &--ligh {
      color: var(--his-oliva);
      font-size: 12px;
      font-weight: 500;
      text-transform: uppercase;
    }

    &--strong {
      color: var(--his-steel-blue);
      font-size: 16px;
      font-weight: 500;
    }
  }

  .grid-1 {
    display: grid;
    grid-template-columns: 1fr;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    grid-column-gap: 10px;
  }
}
</style>
